import { Permissions } from './masterdata';

function createDrawerItem({
  text,
  route,
  show = true,
  openInNewTab = false,
  openInSameTab = false,
  items = null,
  addt = {},
}) {
  return show
    ? {
        text,
        icon: null,
        meta: openInNewTab || openInSameTab ? 'open_in_new' : null,
        anchor: {
          route,
          target: openInNewTab ? 'blank' : openInSameTab ? 'same' : 'self',
        },
        items,
        ...addt,
      }
    : null;
}

// This is the data to create drawer items for when you're on the
// partner tab. Most transforms will be done in the drawer transformer.
// The only filtering that will be done HERE is if we want to `show` a
// drawer item or not. This allows an explicit disable of a drawer item.
export default {
  partner: [
    {
      text: 'Partner',
      items: [
        createDrawerItem({
          text: 'Summary',
          route: 'products',
        }),
        createDrawerItem({
          text: 'Pricing',
          route: 'pricing',
          addt: {
            roles: ['SuperAdmin'],
          },
        }),
        createDrawerItem({
          text: 'FileGuardian Administration',
          route: 'fg-admin',
          addt: {
            roles: ['SuperAdmin'],
            permissions: [Permissions.canViewFileGuardianDetails],
          },
        }),
        //I need to do the permissions still.
        createDrawerItem({
          text: 'Partner Default Settings',
          items: [
            createDrawerItem({
              text: 'General Info',
              route: 'general-info',
              show: true,
              addt: {
                roles: ['SuperAdmin'],
              },
            }),
            createDrawerItem({
              text: 'Employee Self Service',
              route: 'ess-settings',
              show: true,
              addt: {
                systems: ['Hub'],
              },
            }),
            createDrawerItem({
              text: 'Onboarding',
              route: 'onboard-settings',
              show: true,
              addt: {
                systems: ['Hub'],
              },
            }),
            createDrawerItem({
              text: 'Document Settings',
              route: 'document-settings',
              show: true,
              addt: {
                systems: ['Hub'],
              },
            }),
          ],
        }),
        createDrawerItem({
          text: 'Login Management',
          items: [
            createDrawerItem({
              text: 'Logins',
              route: 'logins',
              show: true,
            }),
            createDrawerItem({
              text: 'Multi-Company Assignment',
              route: 'multi-company-assignment',
              show: true,
            }),
          ],
          addt: {
            permissions: [
              Permissions.canAddAndEditPartnerLoginsPermissions,
              Permissions.canAddEditCompanyOperations,
            ],
          },
        }),
        createDrawerItem({
          text: 'Partner User Management',
          route: 'user-management',
          // This drawer item is hidden for now.
          show: false,
        }),
        createDrawerItem({
          text: 'Hardware Clocks',
          route: 'partner-hardware-clocks',
        }),
        createDrawerItem({ text: 'Integration', route: 'partner-integration' }),
        createDrawerItem({
          text: 'Billing Administration',
          items: [
            createDrawerItem({
              text: 'In App Billing History',
              route: 'in-app-billing',
              show: true,
            }),
            createDrawerItem({
              text: 'Trial Administration',
              route: 'trial-admin',
              show: true,
            }),
          ],
          addt: {
            roles: ['SuperAdmin'],
            permissions: [Permissions.canViewBilling],
          },
        }),
        createDrawerItem({
          text: 'TimeWorksPlus Portal',
          route: 'twp-portal',
          openInSameTab: true,
          openInNewTab: false,
          addt: {
            // We only show this option when a partner _can_ sell
            // legacy products. Otherwise, it's hidden.
            onlyIfPartnerCanSellLegacy: true,
            permissions: [Permissions.canAccessTwpPortal],
          },
        }),
        createDrawerItem({
          text: 'Support Center',
          route: 'support-center',
          openInNewTab: true,
        }),
        createDrawerItem({
          text: 'Marketing Content',
          route: 'marketing-content',
          openInNewTab: true,
        }),
        createDrawerItem({
          text: 'Suggestion Box',
          route: 'suggestion-box',
          openInNewTab: true,
        }),
        // Filter out any items that we're not showing right now.
      ].filter(Boolean),
    },
  ],
};
